import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { FileKind } from "../../modes/define/FileKind";
import { UIKind } from "../../modes/define/UIKind";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../modes/normalMode/BundleResourceConfig";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import BasePopUpLayer from "../components/BasePopUpLayer";
import O1HD from "../gameEngine";
import CsvDataManage from "../managers/CsvDataManage";
import { UI_Z_INDEX } from "../modules/uiModule";
import utilsCondition from "./utilsCondition";
import utilsModel from "./utilsModel";

export default class utilsView {

    static popupList: string[] = [];
    /**
     * 刷新文本宽高 
     * */
    static refreshLabelUI(label: cc.Label) {
        label['_forceUpdateRenderData']();
    }

    static setNodeVisible(node: cc.Node, visible: boolean) {
        if (!node) {
            return;
        }
        node.active = visible;
    }

    static openPopupLayer(
        filePath: string
        , bundle: BUNDLE_SMALL_NAME
        , parent?: cc.Node
        , data?: any
        , zIndex: number = 0
        , onComplete?: (node: cc.Node)=>void
        , bShowLoad: boolean = true
        , bLoadOne: boolean = false
    ) {
        let ePath = bundle + filePath;
        if (bLoadOne) {
            if (this.popupList.includes(ePath)) {
                console.log('重复打开');
                return;
            }
            this.popupList.push(ePath);
        }
        
        getOneBundleOnePrefab(bundle, filePath, bShowLoad).then(function(prefab){
            if (!prefab) {
                utilsView.clearPopupPath(ePath);    
                console.error(`加载预制体失败 path = ${filePath}`);
                return;
            }
            utilsView.clearPopupPath(ePath);
            let layer = cc.instantiate(prefab);
            parent = parent || O1HD.Canvas();
            parent.addChild(layer, zIndex);
            if (data) {
                let layerScript = layer.getComponent(BasePopUpLayer);
                if (layerScript) {
                    layerScript.setCarryData(data);
                }
            }
            if (onComplete) {
                onComplete(layer);
            }
        });
    }

    static clearPopupPath(strPath: string) {
        let idx = this.popupList.indexOf(strPath);
        if (idx != -1) {
            this.popupList.splice(idx, 1);
        }
    }

    static openPopupLayerTwo(
        pathInfo: FileKind.PrefabFileInfo
        , parent?: cc.Node
        , data?: any
        , zIndex: number = 0
        , onComplete?: (node: cc.Node)=>void
        , bShowLoad: boolean = true
    ) {
        this.openPopupLayer(pathInfo.filePath, pathInfo.bundle, parent, data, zIndex, onComplete, bShowLoad);
    }

    /**
     * 进入界面处理
     * @param tag 
     */
    static enterLayerDispose(
        tag: string
        , layerNode: cc.Node
        , fFirstCb?: ()=> void
    ) {
        
        let csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.FIRST_ENTER_LAYER, tag);
        if (!csvInfo) {
            console.log(`未找到表格数据`);
            return false;
        }
        if (!utilsModel.isValidNumberValue(csvInfo.event_id)) {
            console.log('无效界面事件索引');
            return false;
        }
        
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let bNoFirst = gameData.firstEnterLayer.includes(tag);
        let strId = tag;
        let bCanSave = true;
        if (bNoFirst && utilsModel.isValidNumberValue(csvInfo.limit_cond)) {
            if (!utilsCondition.isMeetCond(csvInfo.limit_cond)) {
                bNoFirst = false;
            }
        }
        // 特殊处理
        if (tag == UIKind.UILayerTag.GOVERNMENT) {
            if (gameData.m_officialLv > 1) {
                strId = tag + 3;
                bNoFirst = gameData.firstEnterLayer.includes(strId);
                if (bNoFirst) {
                    return false;
                }
            } else {
                if (bNoFirst) {
                    strId = tag + 2;
                    bNoFirst = false;
                    bCanSave = false;
                }
            }
        } else if (tag == UIKind.UILayerTag.EXAM) {
            if (bNoFirst) {
                strId = tag + 2;
                bNoFirst = false;
                bCanSave = false;
            }
        } 
        // else if (tag == UIKind.UILayerTag.MansionLayer) {
        //     if (bNoFirst) {
        //         strId = tag + 2;
        //         bNoFirst = false;
        //         bCanSave = false;
        //     }
        // }

        if (bNoFirst) {
            return false;
        }

        this.openEventLayer(
            null
            , {
                id: strId
                , eventCsv: CsvFileKind.CsvFile.FIRST_ENTER_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.FIRST_ENTER_LAYER
                , saveData: ()=> {
                    if (bCanSave) {
                        if (!gameData.firstEnterLayer.includes(strId)) {
                            gameData.firstEnterLayer.push(strId);
                            gameManager.writeGameData();

                            if (fFirstCb) {
                                fFirstCb();
                            }
                        }
                    }
                }
                , exitLayer: ()=> {
                    layerNode.destroy();
                }
            }
            , UI_Z_INDEX.DIALOG
        );
        return true;
    }

    /**
     * 图片置灰
     * @param sprite 
     */
    static setSpriteGray(sprite: cc.Sprite) {
        let material = cc.Material.getBuiltinMaterial('2d-gray-sprite');
        // let material = cc.Material.getBuiltinMaterial('builtin-2d-gray-sprite');
        sprite.setMaterial(0, material);
    }

    /**
     * 还原图片材质
     * @param sprite 
     */
    static setSpriteBuiltinMaterials(sprite: cc.Sprite) {
        let material = cc.Material.getBuiltinMaterial('2d-sprite');
        sprite.setMaterial(0, material);
    }

    static openEventLayer(
        parent?: cc.Node
        , data?: any
        , zIndex: number = 0
    ) {
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.EnterLayerEventShow);
        this.openPopupLayerTwo(
            FileKind.PrefabFilePath.EnterLayerEventShow
            , parent
            , data
            , zIndex
            , null
            , false
        );
    }

    static async openGetGoodsLayer(
        addGold: number
        , addExp: number
        , addGoodsList: any
    ) {
        return new Promise<void> (resolve=> {
            this.openPopupLayerTwo(
                FileKind.PrefabFilePath.EventGetGoodsLayer
                , null
                , {
                    parent: this
                    , addGold: addGold
                    , addExp: addExp
                    , addGoodsList: addGoodsList
                    , onComplete: ()=> {
                        resolve();
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        });
    }

    /**
     * 加载一张道具icon图片显示
     * @param url
     * @param sprite
     * @param maxSize
     */
    static async loadItemImg(
        url: string
        , sprite: cc.Sprite
        , maxSize: number = null
        , bundleName?: BUNDLE_SMALL_NAME
    ) {
        let bundle = O1HD.getModules().uiControlModule.getGameBundle();
        if (bundleName) {
            bundle = await getOneBundle(bundleName,false);
        }
        bundle.load(url, cc.Texture2D, (e, ass: cc.Texture2D) => {
            if (e) {
                console.warn("图片加载失败", e)
                return
            }
            const spriteFrame = new cc.SpriteFrame(ass);
            sprite.spriteFrame = spriteFrame;
            if (sprite.node == null) { return; }
            if (maxSize) {
                const max = Math.max(spriteFrame.getOriginalSize().width, spriteFrame.getOriginalSize().height);
                if (max == spriteFrame.getOriginalSize().width) {
                    sprite.node.width = maxSize;
                    const scale = maxSize / spriteFrame.getOriginalSize().width;
                    sprite.node.height = spriteFrame.getOriginalSize().height * scale;
                } else {
                    sprite.node.height = maxSize;
                    const scale = maxSize / spriteFrame.getOriginalSize().height;
                    sprite.node.width = spriteFrame.getOriginalSize().width * scale;
                }
            }
            // sprite.spriteFrame=
        })
    }

    /**
     * 加载物品资源
     * @param spr 
     * @param icon 
     */
    static async loadGoodsSpriteFrame(
        spr: cc.Sprite
        , icon: string
        , bShowLoad: boolean = true
        , bMaxSize: number = null
    ) {
        let iconPath = "backpackAssets/objSp/" + icon;
        spr.node.active = false;
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle, bShowLoad);
        bundle.load(iconPath, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    spr.node.active = true;
                    spr.spriteFrame = imgs;

                    if (bMaxSize) {
                        let scale = Math.min(bMaxSize / spr.node.width, bMaxSize / spr.node.height);
                        spr.node.scale = scale;
                    }
                }
            }
        );
    }
}

